import { Checkbox as CheckboxBase, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  /* margin: 1rem 0rem; */
`;

export const LabelWrapper = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    .MuiTypography-root {
      font-family: ${props => props.theme.fontDefault}!important;
      margin-top: 2px !important;
      font-size: 0.9rem;
    }
  }
`;

export const Cbx = styled(CheckboxBase)`
  &.MuiCheckbox-root {
    color: #c4c4c4;
  }

  &.MuiIconButton-root.Mui-disabled {
    color: #c4c4c4 !important;
    opacity: 0.7;
  }

  &.MuiCheckbox-colorSecondary.Mui-checked {
    color: #166649 !important;
  }
`;
